import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
const Dashboard = lazy(() => import('./pages/Dashboard'));
const MojObracun = lazy(() => import('./pages/MojObracun'));
const Uposlenici = lazy(() => import('./pages/Uposlenici'));
const OpstePostavke = lazy(() => import('./pages/OpstePostavke'));
const Historija = lazy(() => import('./pages/Historija'));
const Korisnici = lazy(() => import('./pages/Korisnici'));

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Stranice se učitavaju tek kad zatrebaju — manji prvi download. */}
        <Suspense fallback={null}>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute trazi="moze_generisati">
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/moj-obracun"
            element={
              <PrivateRoute>
                <MojObracun />
              </PrivateRoute>
            }
          />

          <Route
            path="/uposlenici"
            element={
              <PrivateRoute trazi="moze_postavke_uposlenika">
                <Uposlenici />
              </PrivateRoute>
            }
          />

          <Route
            path="/postavke"
            element={
              <PrivateRoute trazi="moze_opste_postavke">
                <OpstePostavke />
              </PrivateRoute>
            }
          />

          <Route
            path="/historija"
            element={
              <PrivateRoute trazi="moze_historija">
                <Historija />
              </PrivateRoute>
            }
          />

          <Route
            path="/korisnici"
            element={
              <PrivateRoute trazi="moze_korisnike">
                <Korisnici />
              </PrivateRoute>
            }
          />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
